import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { ContentAuthoringService } from "../../services/content-authoring.service";
import { AssessmentService } from "../../services/assessment.service";
import { NgbModal, ModalDismissReasons, NgbPaginationConfig, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { CourseService } from '../../services/course.service';
import { ToastrService } from 'ngx-toastr';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

@Component({
  selector: 'app-courses-assign-users',
  templateUrl: './courses-assign-users.component.html',
  styleUrls: ['./courses-assign-users.component.scss']
})
export class CoursesAssignUsersComponent implements OnInit {
  searchText: any = ""; order_by = 'created_dttm'; filter_by: any = ""; is_active: any = '1'; order: any = 'DESC';
  showDetails: boolean = false; userData: any; organisationData: any; selectUserId: any = [];
  activeCourse: boolean = true;
  succesCourse: boolean = false;
  checkboxValue: string='';
  isCheckeds:any = false;
  isChecked: any;
  panelOpenState = false; adminData: any; cousesData: any = []; courseForm: any = [];
  checkedUser:any=[];
  activeTab = 0; courseId: any = ''; courseIdNum: any; tab: any = ''; courseData: any; user_type:number=1;
  @ViewChild('searchUser', {static:true})searchUser:ElementRef | undefined
  totalUserDetail: any;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private contentAuthoringApi: ContentAuthoringService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal, private toastr: ToastrService, private authCourse: CourseService) { }

  /*****get couse detail ****/
  getCourseAuthDetails(courseId: any) {
    this.spinner.show();
    this.authCourse.CourseDetail(courseId).subscribe(
      data => {
        this.courseData = data.courseData
        this.spinner.hide();
        //console.log(data);

      }, error => {
        this.spinner.hide();

      }
    )
  }
  open(content: any) {
    this.modalService.open(content, { centered: true, size: 'md' });
  }
  /****** start create duplicate course */
  duplicateCourse() {
    /*****get couse detail ****/
    this.authCourse.CourseDetail(this.courseId).subscribe(
      data => {
        this.cousesData = data.courseData;
        this.courseForm = {
          "course_desc": data.courseData.course_desc,
          "course_id": "",
          "course_image": data.courseData.course_image,
          "course_name": data.courseData.course_name + '_copy',
          //"course_status": data.courseData.course_status,
          "course_status": 1,
          "created_by": data.courseData.db_created_dttm,
          "end_date": data.courseData.db_end_date,
          "is_active": data.courseData.is_active
        }
        this.authCourse.dublicateCourse(this.courseForm).subscribe(
          (data) => {
            if (this.cousesData.courseModules.length > 0 && data.status == 201) {
              this.getModuleData(data.course_id);
            } else {
              document.getElementById('closelId')?.click();
              this.spinner.hide();
              this.router.navigate(['/courses']);
            }
          }, error => { })
      })
  }
  getModuleData(courseId: any) {
    if (this.cousesData && this.cousesData.courseModules) {
      let arr: Array<any> = this.cousesData.courseModules;
      arr.forEach((element,i) => {
        setTimeout(() => {
        let qts = element.subModules;
        for (let n = 0; n < qts.length; n++) {
          qts[n]['course_id'] = courseId;
          qts[n]['created_dttm'] = qts[n].db_created_dttm;
          qts[n]['created_by'] = qts[n].db_created_by;
        }
        element['course_id'] = courseId;
        element['created_dttm'] = element.db_created_dttm;
        element['created_by'] = element.db_created_by;
        element['subModules'] = qts;
        if(this.cousesData.courseModules.length-1==i){
          this.duplicateModule(element,1);
        }else{
          this.duplicateModule(element,0);
        }
      }, i*2000);
      })
     // this.spinner.hide();
    }
  }
   /*****create duplicate modules of course */
   duplicateModule(Modueldata: any,status:any) {
    this.authCourse.creatModule(Modueldata, 'create').subscribe(
      data => {
        if(status==1){
          this.router.navigate(['/courses']);
          document.getElementById('closelId')?.click();
          this.spinner.hide();
        }
      }, error => {
        this.spinner.hide();
       })
    
  }
  onChangeDemo(e: any, Id: any, indexs: any) {
    if (e.checked == true) {
      this.selectUserId[indexs] = Id;
      console.log(this.selectUserId)
    } else { 
      const index = this.selectUserId.indexOf(Id);
      this.selectUserId.splice(index, 1); 
     // this.userData[Id].checked=false;
      //console.log(this.userData[Id])
    }
  }
  
  /****** END create duplicate course */
  getUsersDetailss(searchText: any, is_active: any, order_by: any, order: any, filter_by: any, user_type:any) {
    // this.spinner.show();
    this.contentAuthoringApi.getUserList(searchText, is_active, order_by, order, filter_by, user_type).subscribe(
      data => {
        this.userData = data.userList
        // this.authCourse.selectedUsers.subscribe(res=> {
        //   this.checkedUser=res;
        //   console.log("checked Users=", this.checkedUser)
        // })
        this.checkBoxHandler(this.userData)
       
        // this.spinner.hide();
      }, error => {
        //this.spinner.hide();

      }
    )
  }
  checkBoxHandler(userData:any){
    for (let i = 0; i < userData.length; i++) {
      if(this.selectUserId.indexOf(userData[i].user_id) !=-1)
       userData[i]["checked"]=true;
       else{
         userData[i]["checked"]=false;
       }
       
     }
  }
  selectChangeHandler(event: any) {
    this.filter_by = event.value;
    if (this.filter_by == 0) {
      this.filter_by = '';
      this.getUsersDetails(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type);
    } else {
      this.getUsersDetails(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type);
    }
  }
  getUsersDetails(searchText: any, is_active: any, order_by: any, order: any, filter_by: any,user_type:any) {
    this.spinner.show();
    this.contentAuthoringApi.getUserList(searchText, is_active, order_by, order, filter_by, user_type).subscribe(
      data => {
        console.log(data);
        this.userData = data.userList
        this.checkBoxHandler(this.userData)
        this.spinner.hide();
      }, error => {
        this.spinner.hide();

      }
    )
  }
  /*******status change in active or deactive  *****/
  changeIsDeActiveVal(is_active: any) {
    this.authCourse.changeIsActiveVal(this.courseId, is_active).subscribe(
      (data) => {
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
          this.getCourseAuthDetails(this.courseId);
          this.router.navigate(['/courses_assign_users'], { queryParams: { courseId: this.courseId } });
        } else {
          // this.errorInfo.isError = true;
          // this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        //this.errorInfo.errorMsg = error;
      },
    );
  }
  // search(event: any) {
  //   this.searchText = event.target.value;
  //   this.getUsersDetailss(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type);
  // }

  sortData(sort: any) {
    if (sort.direction == 'desc') {
      this.order_by = sort.active; this.order = 'DESC';
    } else if (sort.direction == 'asc') {
      this.order_by = sort.active; this.order = 'ASC';
    } else { this.order_by = 'end_date'; this.order = 'DESC'; }
    this.getUsersDetails(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type);
  }
  getOrganisationList(is_active: any) {
    this.contentAuthoringApi.getOrganisationList("", is_active,this.order_by,this.order).subscribe(
      (data) => {
        if (data.success) {
          //console.log(data)
          this.organisationData = data.organisationList;
        } else { }
      },
      (error) => { },
    );
  }
 
  
  publish() {
    this.selectUserId = this.selectUserId.filter(function (e: any) { return e != null; });
    console.log(this.selectUserId);
    this.spinner.show();
    this.authCourse.AssignUsers(this.courseId, this.selectUserId).subscribe(
      (data) => {
        document.getElementById('CloseIds')?.click();
        this.router.navigate(['/courses']);
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
      },
    );
  }
  logout() {
   // localStorage.clear();
    localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
  ngOnInit(): void {
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.getOrganisationList(this.is_active);
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.courseId = queryParams['courseId'];
      this.tab = queryParams['tab'];
      this.courseIdNum = parseInt(this.courseId);
    });
    if (this.courseId != '' && this.courseId != null) {
      this.getCourseAuthDetails(this.courseId);
    }
    this.getUsersDetails(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type);
    fromEvent(this.searchUser?.nativeElement, 'keyup').pipe(
      map((e:any)=> e?.target.value),debounceTime(1000)
    ).subscribe((res:any)=>{
      this.searchText=res
      this.getUsersDetails(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type);
    })
  }
  onChange(ob: MatCheckboxChange) {
    this.checkboxValue = ob.source.id;
    this.isChecked = ob.checked
    this.selectUserId=[]
    this.manageCheckBoxAll(ob.checked)
     if (this.checkboxValue == "all" && this.isChecked) {
       this.isCheckeds= true;
       this.allchecked();
     }
     if (this.checkboxValue == "all" && !this.isChecked) {
      this.isCheckeds= false;
      //this.selectUserId=[]
    }
   
  }
  manageCheckBoxAll(ischecked:boolean){
    this.userData.forEach((element:any) => {
      element["checked"]=ischecked?true:false
    });
  }
  allchecked(){
    let arr: Array<any> = this.userData;
    //arr.forEach(element => {
     // alert(this.userData.length);
      //console.log( element.courses_assigned_list);
      //element.courses_assigned_list) 
    //});
    for(let i = 0; i < this.userData.length; i++){
      if(this.userData[i].courses_assigned_list.indexOf(this.courseIdNum) == -1){
        this.selectUserId[i] = this.userData[i].user_id;
      };
    }
  // console.log(this.selectUserId);

  }
}
